module.exports = __webpack_public_path__ + "static/img/wxpay.4be897a3.png";